// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightPreprintReport-cls1_rmV","cls2":"CiterightPreprintReport-cls2_x7a CiterightPreprintReport-cls1_rmV"};